import React, {useContext} from 'react';
import {migrateSenderDocuments} from '../../services';
import PropTypes from 'prop-types';
import {Col, Row} from "reactstrap";
import {RefreshContext} from "../../Elements/Fetch";
import FormWithActions from "../../Elements/FormWithActions/FormWithActions";

const DocumentsMigrationForm = ({sender, onSubmit}) => {
    const {triggerRefresh} = useContext(RefreshContext);

    const handleAction = async () => {
        const data = await migrateSenderDocuments(sender.id)
        triggerRefresh(`sender:${sender.id}`)
        onSubmit()

        return data
    }

    return (
        <>
            <Row>
                <Col>
                    <h1 className="mb-5">
                        Migrate Sender Documents
                    </h1>
                </Col>
            </Row>
            <FormWithActions onAction={handleAction} submitButton="Migrate">



            </FormWithActions>
        </>
    );

}

DocumentsMigrationForm.propTypes = {
    sender: PropTypes.shape({
        id: PropTypes.number.isRequired,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default DocumentsMigrationForm;